module.exports = __webpack_public_path__ + "static/media/ToDoOrNotToDo.ad461bb0.gif";